import React, { useMemo } from "react";
import propTypes from "prop-types";
import topJawIcon from "../Formula3DPreview/Formula3DPreviewControls/controlIcons/controlsTop.png";
import bottomJawIcon from "../Formula3DPreview/Formula3DPreviewControls/controlIcons/controlsBottom.png";
import translates from "../Formula/translates";
import FormulaTotalInformationData from "../Formula/FormulaTotalInformationData";
import { surgicalPartTotalInfoFilter } from "../formulaHelpers";
import "./index.scss";
import { TranslateProvider, useTranslation } from "../../i18n";

const FormulaTotalInformation = ({
  formulaInformation,
  type,
  pdfColors = false
}) => {
  const {
    _t
  } = useTranslation();
  const {
    tooth,
    prosthesis,
    gaps,
    jointDisease
  } = useMemo(() => {
    if (type === "surgical") {
      return surgicalPartTotalInfoFilter(formulaInformation);
    }

    return {
      tooth: formulaInformation.tooth || [],
      prosthesis: formulaInformation.prosthesis || [],
      gaps: formulaInformation.gaps || []
    };
  }, [formulaInformation, type]);
  const {
    prostheticsTooth,
    upperJaw,
    lowerJaw,
    gapsTop,
    gapsBottom,
    prosthesisTop,
    prosthesisBottom
  } = FormulaTotalInformationData({
    tooth,
    gaps,
    prosthesis,
    jointDisease
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `formulaTotalInformation ${pdfColors ? "pdfColors" : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "formulaTotalInformation-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "formulaTotalInformation-section top"
  }, /*#__PURE__*/React.createElement("img", {
    src: topJawIcon,
    className: "formulaTotalInformation-section-icon",
    alt: ""
  }), _t("Верхняя челюсть")), /*#__PURE__*/React.createElement("div", {
    className: "halfPart partTitle"
  }, /*#__PURE__*/React.createElement("div", null, `${_t("Сегмент")} 1`)), /*#__PURE__*/React.createElement("div", {
    className: "halfPart partTitle"
  }, /*#__PURE__*/React.createElement("div", null, `${_t("Сегмент")} 2`)), /*#__PURE__*/React.createElement("div", {
    className: "halfPart"
  }, upperJaw.filter(el => el.elSection === 1).map(item => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: item.name,
    item: item
  }))), /*#__PURE__*/React.createElement("div", {
    className: "halfPart"
  }, upperJaw.filter(el => el.elSection === 2).map(item => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: item.name,
    item: item
  }))), /*#__PURE__*/React.createElement("div", {
    className: "halfPart"
  }, gapsTop.filter(el => el.elSection === 1).map(gap => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: gap.name,
    item: gap
  }))), /*#__PURE__*/React.createElement("div", {
    className: "halfPart"
  }, gapsTop.filter(el => el.elSection === 2).map(gap => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: gap.name,
    item: gap
  }))), prosthesisTop.map(prothes => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: prothes,
    item: prothes,
    prostheticsTooth: prostheticsTooth
  }))), /*#__PURE__*/React.createElement("div", {
    className: "formulaTotalInformation-part"
  }, /*#__PURE__*/React.createElement("div", {
    className: "formulaTotalInformation-section bottom"
  }, /*#__PURE__*/React.createElement("img", {
    src: bottomJawIcon,
    className: "formulaTotalInformation-section-icon",
    alt: ""
  }), _t("Нижняя челюсть")), /*#__PURE__*/React.createElement("div", {
    className: "halfPart partTitle"
  }, /*#__PURE__*/React.createElement("div", null, `${_t("Сегмент")} 3`)), /*#__PURE__*/React.createElement("div", {
    className: "halfPart partTitle"
  }, /*#__PURE__*/React.createElement("div", null, `${_t("Сегмент")} 4`)), /*#__PURE__*/React.createElement("div", {
    className: "halfPart"
  }, lowerJaw.filter(el => el.elSection === 3).map(item => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: item.name,
    item: item
  }))), /*#__PURE__*/React.createElement("div", {
    className: "halfPart"
  }, lowerJaw.filter(el => el.elSection === 4).map(item => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: item.name,
    item: item
  }))), /*#__PURE__*/React.createElement("div", {
    className: "halfPart"
  }, gapsBottom.filter(el => el.elSection === 3).map(gap => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: gap.name,
    item: gap
  }))), /*#__PURE__*/React.createElement("div", {
    className: "halfPart"
  }, gapsBottom.filter(el => el.elSection === 4).map(gap => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: gap.name,
    item: gap
  }))), prosthesisBottom.map(prothes => /*#__PURE__*/React.createElement(ItemTemplate, {
    key: prothes,
    item: prothes,
    prostheticsTooth: prostheticsTooth
  }))));
};

const cancelToothList = ["totalTop", "totalBottom", "orthodonticPlateTop", "orthodonticPlateBottom", "elastopositioner", "slideSapphireBracesTop", "slideSapphireBracesBottom", "slideSelfAlignBracesTop", "slideSelfAlignBracesBottom", "slideCeramicBracesTop", "slideCeramicBracesBottom", "slideCeramicSelfAlignBracesTop", "slideCeramicSelfAlignBracesBottom", "slideMetallBracesTop", "slideMetallBracesBottom", "slideLingualBracesTop", "slideLingualBracesBottom", "slideMouthAlignerTop", "slideMouthAlignerBottom"];
const activityDisabledMask = ["therapyRestoration"];

const ItemTemplate = ({
  item,
  prostheticsTooth = null
}) => {
  const {
    _t,
    language
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: "toothInfo"
  }, item.hasOwnProperty("name") && /*#__PURE__*/React.createElement("div", {
    className: `toothInfo-title ${item.name.length === 4 ? "double" : ""} `
  }, item.name.length === 4 ? `${item.name.substring(0, 2)}-${item.name.substring(2, 4)}` : item.name), /*#__PURE__*/React.createElement("div", {
    className: `toothInfo-element ${prostheticsTooth ?? "totalItem"}`
  }, item.hasOwnProperty("toothElementsActive") && item.toothElementsActive.map(activity => /*#__PURE__*/React.createElement("div", {
    className: "toothInfo-content",
    key: activity
  }, /*#__PURE__*/React.createElement("img", {
    className: "toothInfo-content-icon",
    src: translates(language, activity).icon,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, translates(language, activity).string, !activityDisabledMask.includes(activity) && item.toothSegments && item.toothSegments[activity] && item.toothSegments[activity].map(section => `, ${translates(language, section).string}`)))), item.hasOwnProperty("activity") && /*#__PURE__*/React.createElement("div", {
    className: "toothInfo-content listItems"
  }, item.activity.length > 0 && item.activity.map(activity => /*#__PURE__*/React.createElement("div", {
    className: "toothInfo-content-listItem",
    key: activity
  }, /*#__PURE__*/React.createElement("img", {
    className: "toothInfo-content-icon",
    src: translates(language, activity).icon,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    key: activity
  }, translates(language, activity).string)))), prostheticsTooth && /*#__PURE__*/React.createElement("div", {
    className: "toothInfo-content"
  }, /*#__PURE__*/React.createElement("img", {
    className: "toothInfo-content-icon",
    src: translates(language, item).icon,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, translates(language, item).string, " ", !cancelToothList.includes(item) && _t("Зубы:")), !cancelToothList.includes(item) && prostheticsTooth.top.map(el => /*#__PURE__*/React.createElement("span", {
    key: el
  }, el, ", "))))));
};

FormulaTotalInformation.propTypes = {
  tooth: propTypes.array.isRequired,
  prosthesis: propTypes.array.isRequired,
  gaps: propTypes.array.isRequired,
  jointDisease: propTypes.array.isRequired
};
FormulaTotalInformation.defaultProps = {
  tooth: [],
  prosthesis: [],
  gaps: [],
  jointDisease: []
};

const FormulaTotalInformationWrapper = props => {
  return /*#__PURE__*/React.createElement(TranslateProvider, null, /*#__PURE__*/React.createElement(FormulaTotalInformation, props));
};

export default FormulaTotalInformationWrapper;